import Radio from 'components/ui/Radio';
import { CSVTableRowProps } from 'types';

const IdColumnRow = ({ rowIndex, columnLabels, isEditMode, values, useFormReturn }: CSVTableRowProps) => {
  const { register } = useFormReturn;

  if (isEditMode) {
    return (
      <tr>
        <th>ID 컬럼</th>
        <td>
          <div>
            <Radio id={`allIdColumn`} {...register('idColumn')} label="미사용" value="none" />
          </div>
        </td>
        {columnLabels.map((label, i) => (
          <td key={`col/${label}/row/${rowIndex}/edit`}>
            {values?.[i] !== undefined && (
              <div>
                <Radio id={`idColumn/${i}`} {...register('idColumn')} value={i} />
              </div>
            )}
          </td>
        ))}
      </tr>
    );
  }

  return (
    <tr>
      <th>{rowIndex}</th>
      {columnLabels.map((label) => (
        <td key={`col/${label}/row/${rowIndex}`}></td>
      ))}
    </tr>
  );
};

export default IdColumnRow;
